import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import { Tooltip } from '../Tooltip';
import { setDataAttributes } from '../util/getDataAttributes';
import { horizontalPadding, StyledItem, StyledItemText, StyledListItem } from './ListItem.styled';
export function ListItem(_ref) {
  var children = _ref.children,
    _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items,
    onClick = _ref.onClick,
    _ref$nestedLevel = _ref.nestedLevel,
    nestedLevel = _ref$nestedLevel === void 0 ? 0 : _ref$nestedLevel,
    List = _ref.List,
    disabled = _ref.disabled,
    tooltip = _ref.tooltip,
    props = _objectWithoutProperties(_ref, ["children", "items", "onClick", "nestedLevel", "List", "disabled", "tooltip"]);
  var style = {
    marginLeft: horizontalPadding * nestedLevel
  };
  var handelKeyDown = function handelKeyDown(e) {
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault();
      var menuItems = document.querySelectorAll('[role="menuitem"]');
      var currentIndex = Array.from(menuItems).indexOf(e.currentTarget);
      var nextIndex = currentIndex;
      nextIndex = nextIndex + (e.key === 'ArrowDown' ? 1 : -1);
      nextIndex = (nextIndex + menuItems.length) % menuItems.length;
      menuItems[nextIndex].focus();
    }
  };
  var onKeyPress = function onKeyPress(e) {
    if (e.key === 'Enter' || e.key === ' ') {
      onClick === null || onClick === void 0 ? void 0 : onClick(e);
    }
  };
  var disabledHandler = function disabledHandler(e) {
    return e.stopPropagation();
  };
  return /*#__PURE__*/React.createElement(Tooltip, {
    hoverTrigger: /*#__PURE__*/React.createElement(StyledListItem, _extends({
      role: "menuitem",
      onClick: !disabled ? onClick : disabledHandler,
      onKeyUp: !disabled ? onKeyPress : disabledHandler,
      onKeyDown: handelKeyDown,
      tabIndex: 0
    }, setDataAttributes(props, 'list-item')), /*#__PURE__*/React.createElement(StyledItem, {
      disabled: disabled
    }, /*#__PURE__*/React.createElement(StyledItemText, {
      style: style
    }, children)), !!items.length && /*#__PURE__*/React.createElement(List, {
      items: items
    })),
    isDisabled: !tooltip,
    placement: "right"
  }, tooltip);
}